<template>
    <div class="login-top">
        <div class="login-container">
            <form class="login-email" @submit.prevent="validateBeforeSubmit" v-if="!onSend">
                <h1 class="heading-1 login-container__heading">Connectez-vous<br /> par un lien généré par email</h1>
                <p>
                    <strong>Abonnement individuel à Egora et/ou à La Revue Française du Dommage Corporel ?</strong>
                    <br>
                    Connectez-vous en cliquant sur le lien envoyé par email.
                </p>
                <div class="login-container__inline">
                    <div class="form-group">
                        <input type="email" class="form-control form-control-lg" v-model="form.email" placeholder="Saisissez votre email..."/>
                    </div>
                    <button v-show="!isMobile" type="submit" class="btn btn-dark btn-lg btn-block">Recevoir mon lien de connexion</button>
                    <button v-show="isMobile" type="submit" class="btn btn-dark btn-lg btn-block">Recevoir</button>
                </div>
                <span class="error" v-if="errors.email">{{ errors.email }}</span>
            </form>

            <div v-if="onSend">
                <p>Le lien de connexion vous a été envoyé par email.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            onSubmit: false,
            onSend: false,
            errors: [],
            response: [],
            form: {
                email: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'setOnLoad'
        ]),
        async validateBeforeSubmit() {
            if (this.onSend) return

            this.errors = []

            if (!this.form.email) {
                this.errors['email'] = 'Email requis'
            } else if (!this.validEmail(this.form.email)) {
                this.errors['email'] = 'Valid email required'
            }

            if (!this.errors.length) {
                this.submit();
            }

            this.onSend = false
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        submit() {
            this.onSubmit = true
            this.setOnLoad(true)

            // Send autoconnect email.
            this.$api.postEmailAutoconnect({
                email: this.form.email
            }).then(response => {
                this.response = response;
                this.setOnLoad(false);
                this.onSend = true;
            }).catch((response) => {
                this.setOnLoad(false);
                this.onSubmit = false;
                this.onSend = false;
                this.response = response;
                this.errors.email = response.response.data.message
            });
        },
    },
    computed: {
        isMobile() {
            return this.$vssWidth < 992
        },
    }
}
</script>

<style lang="scss">
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

  .login-container {
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
      padding: 0 20px;
      position: relative;
      z-index: 1;
      
    &__inline {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 25px;
        background: $white;
        padding: 5px;

        .form-group {
            margin: 0;
        }
    }

    &__heading {
        margin: 0 0 9px;
    }

    button {
        padding: 14px 25px;
        white-space: nowrap;
        overflow: hidden;

        @include min($lg) {
            padding: 14px 31px;
        }
    }

    p {
        margin: 0 0 20px;
    }

    form {
        width: 100%;
        max-width: 464px;
    }

    .login-email {
        max-width: inherit;
    }
  }

  .login-form {
    width: 100%;
    max-width: 465px;
  }

  .login-top {
    padding: 45px 0 42px;
    position: relative;
    

    @include min($lg) {
        padding: 85px 0 50px;
    }

    &:before {
        content: ' ';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        background: url(../../assets/images/login-bg.jpg) 0 0 no-repeat $darkgray;
        background-position: 50% 0;
        z-index: 0;

        @include min($lg) {
            background-size: 100% auto;
        }
    }

    input, button {
        margin: 0;
        font-size: 15px;
        line-height: 15px;
    }

    input {
        padding: 20px;
        background: none;
        box-shadow: none;
        border: none;
    }

  }

</style>